{
  "Repo": "https://lba-consulting@dev.azure.com/lba-consulting/Abercrombie%20and%20Kent/_git/AK%20Frontend%20Reservation",
  "LastCommitHash": "9d33d4ab69dcab108d1344a1046412181a1c986a",
  "LastCommitMessage": "Merge branch uat_price-setup-changes into dev-update-version19",
  "LastCommitAuthor": "francesco.moroni",
  "LastCommitTime": "Tue Nov 3 16:44:32 2026 +0100",
  "VersionNumber": "21959"
}